import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../component-base';
import { CurrentUserService } from '../../services/current-user.service';
import { UsersService } from '../../services/users.service';
import { ApiResponse } from '../../models/api-response.model';
import { UserDto } from '../../models/user';

@Component({
  selector: 'request-submitter-info',
  templateUrl: './request-submitter-info.component.html'
})
export class RequestSubmitterInfoComponent extends BaseComponent implements OnInit {
  @Input() showInReviewPane: boolean = false;
  @Input() requestId: string;
  userDto: UserDto;
  constructor(public usersService: UsersService) {
    super();
  }
  ngOnInit() {
    this.usersService.getRequestSubmitterInfo(this.requestId)
    .subscribe((data: ApiResponse<UserDto>) => {
      this.userDto = data.value;
    });
  }
}
